import AlertItem from './AlertItem';

import AlertItemConnect from '../AlertItemConnect';

export default AlertItemConnect(AlertItem);
